/**
 * Consent-gated GA4 events for the paid video funnel.
 * Policy-safe: no PII (no email/name/order id), no ad-click incentives,
 * analytics only after cookie consent — aligned with ADSENSE-POLICY.md +
 * https://support.google.com/adsense/answer/48182
 */
export const trackPaywallFunnelEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (!window.gtag || !window.cookieConsentGiven) {
    return;
  }
  window.gtag('event', eventName, {
    event_category: 'Video Paywall',
    ...params,
  });
};
